import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { AdminHeader, Card, Empty, Input } from "@/components/admin/ui";
import { formatINR } from "@/lib/format";
import { toast } from "sonner";
import { Printer } from "lucide-react";

export default function AdminBilling() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/admin/invoices").then(({ data }) => setRows(data.invoices)).catch(() => setRows([]));
  }, []);
  if (!rows) return null;

  const needle = q.trim().toLowerCase();
  const filtered = needle
    ? rows.filter((r) => [r.invoiceNumber, r.orderNumber, r.buyer?.name, r.seller?.gstin]
        .filter(Boolean).some((v) => String(v).toLowerCase().includes(needle)))
    : rows;

  const openInvoice = async (id) => {
    try {
      const html = await api.get(`/admin/invoices/${id}/html`,
        { responseType: "text", transformResponse: (r) => r });
      const w = window.open("", "_blank");
      if (w) { w.document.write(html.data); w.document.close(); }
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <AdminHeader title="Billing" subtitle="GST invoices for paid orders" />
      <Card className="p-5 mb-6">
        <Input label="Search invoices" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Invoice, order number, customer or GSTIN" testid="invoice-search" />
      </Card>
      <Card className="overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
            <tr>
              <th className="p-3">Invoice</th><th className="p-3">Order</th><th className="p-3">Date</th>
              <th className="p-3">Customer</th><th className="p-3">GSTIN</th><th className="p-3">Total</th><th className="p-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {filtered.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50">
                <td className="p-3 font-mono text-xs">{r.invoiceNumber}</td>
                <td className="p-3 font-mono text-xs">{r.orderNumber}</td>
                <td className="p-3 text-xs text-slate-500">{r.createdAt ? new Date(r.createdAt).toLocaleDateString("en-IN") : "—"}</td>
                <td className="p-3">{r.buyer?.name || "—"}</td>
                <td className="p-3 font-mono text-xs">{r.seller?.gstin || "—"}</td>
                <td className="p-3 font-mono">{formatINR(r.totals?.total)}</td>
                <td className="p-3">
                  <button onClick={() => openInvoice(r.id)} className="inline-flex items-center gap-1 text-amber-600 text-xs font-semibold" data-testid={`print-invoice-${r.invoiceNumber}`}>
                    <Printer className="h-3.5 w-3.5" /> Print
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <Empty text="No invoices yet" />}
      </Card>
    </div>
  );
}